"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var operators_1 = require("rxjs/operators");
var actions_types_enum_1 = require("../actions-types.enum");
var constants_1 = require("./constants");
var logging_utilities_1 = require("./logging.utilities");
var logger = logging_utilities_1.createLogger('dynamic-entity-store-manager');
var DynamicEntityStoreManager = /** @class */ (function () {
    function DynamicEntityStoreManager(path, keyExtractor, prefix) {
        var _this = this;
        this.path = path;
        this.keyExtractor = keyExtractor;
        this.prefix = prefix;
        this.selectAll = lodash_1.memoize(this.loadAll, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return "" + _this.path + (lodash_1.isNil(_this.prefix) ? '' : '.' + _this.prefix) + "." + args[1];
        });
    }
    DynamicEntityStoreManager.prototype.actionType = function (standardType) {
        return this.path + " " + standardType;
    };
    DynamicEntityStoreManager.prototype.createAction = function (standardType, subPath, payload, _additionalData) {
        var additionalData = this.assignPrefixIfNeeded(_additionalData);
        switch (standardType) {
            case actions_types_enum_1.StandardActionTypes.LOAD_ALL:
                return {
                    type: this.actionType(standardType),
                    subPath: subPath,
                    additionalData: additionalData,
                };
            case actions_types_enum_1.StandardActionTypes.UPDATE_MANY_SUCCESS:
            case actions_types_enum_1.StandardActionTypes.UPDATE_MANY:
                return {
                    type: this.actionType(standardType),
                    items: payload,
                    subPath: subPath,
                    additionalData: additionalData,
                };
            case actions_types_enum_1.StandardActionTypes.LOAD_MANY_SUCCESS:
                return {
                    type: this.actionType(standardType),
                    items: payload,
                    subPath: subPath,
                    additionalData: additionalData,
                };
            case actions_types_enum_1.StandardActionTypes.LOAD_ONE:
                return {
                    type: this.actionType(standardType),
                    id: payload,
                    subPath: subPath,
                    additionalData: additionalData,
                };
            case actions_types_enum_1.StandardActionTypes.CREATE:
            case actions_types_enum_1.StandardActionTypes.UPDATE:
                return {
                    type: this.actionType(standardType),
                    item: payload,
                    subPath: subPath,
                    additionalData: additionalData,
                };
            case actions_types_enum_1.StandardActionTypes.LOAD_ONE_SUCCESS:
            case actions_types_enum_1.StandardActionTypes.CREATE_SUCCESS:
            case actions_types_enum_1.StandardActionTypes.DELETE:
            case actions_types_enum_1.StandardActionTypes.DELETE_SUCCESS:
            case actions_types_enum_1.StandardActionTypes.UPDATE_SUCCESS:
                return {
                    type: this.actionType(standardType),
                    item: payload,
                    subPath: subPath,
                    additionalData: additionalData,
                };
            case actions_types_enum_1.StandardActionTypes.CREATE_FAIL:
            case actions_types_enum_1.StandardActionTypes.ENTITY_ERROR:
                return {
                    type: this.actionType(standardType),
                    error: payload,
                };
            default:
                return undefined;
        }
    };
    DynamicEntityStoreManager.prototype.loadAll = function (store, subPath, additionalData) {
        var _this = this;
        store.dispatch(this.createAction(actions_types_enum_1.StandardActionTypes.LOAD_ALL, subPath, undefined, additionalData));
        logger.debug('loading following store item with following key %s', this.path + "." + subPath);
        return this.fullyLoaded(store, subPath).pipe(operators_1.switchMap(function () {
            return store.select(function (state) { return lodash_1.get(state, _this.getPathExtended()); });
        }), operators_1.filter(function (value) {
            return !lodash_1.isNil(value) && !value.get(subPath, immutable_1.List()).isEmpty();
        }), operators_1.map(function (value) { return value.get(subPath, immutable_1.List()); }), operators_1.publishReplay(1), operators_1.refCount(), operators_1.distinct());
    };
    DynamicEntityStoreManager.prototype.clearCache = function () {
        this.selectAll.cache.clear();
    };
    DynamicEntityStoreManager.prototype.selectOne = function (store, id, subPath, additionalData) {
        var _this = this;
        store.dispatch(this.createAction(actions_types_enum_1.StandardActionTypes.LOAD_ONE, subPath, id, additionalData));
        return this.selectAll(store, subPath).pipe(operators_1.map(function (items) {
            return items.find(function (item) {
                return String(_this.keyExtractor(item)).toLocaleLowerCase() ===
                    String(id).toLocaleLowerCase();
            });
        }));
    };
    DynamicEntityStoreManager.prototype.getPathExtended = function () {
        return "" + this.path + (lodash_1.isNil(this.prefix) ? '' : '.' + this.prefix);
    };
    DynamicEntityStoreManager.prototype.assignPrefixIfNeeded = function (additionalData) {
        if (this.prefix) {
            return lodash_1.assign(additionalData, { __prefix__: this.prefix });
        }
        return additionalData;
    };
    DynamicEntityStoreManager.prototype.fullyLoaded = function (store, subPath) {
        var loadingStatus = this.getPathExtended().split('.')[0] + '.' + constants_1.loadingStatusKey;
        var loadStatusPath = this.getPathExtended()
            .split('.')
            .slice(1).concat([
            subPath,
        ]).join('.');
        return store
            .select(function (state) { return lodash_1.get(state, loadingStatus); })
            .pipe(operators_1.map(function (status) { return lodash_1.isNil(status) || lodash_1.get(status, loadStatusPath); }), operators_1.filter(Boolean), operators_1.first());
    };
    return DynamicEntityStoreManager;
}());
exports.DynamicEntityStoreManager = DynamicEntityStoreManager;
//# sourceMappingURL=dynamic-entity-store.manager.js.map